import axios from 'axios';
import { apiPaths } from 'constants/path';
import { clAdminTokenHeader } from 'functions/apiFunctions';
import { CLAiChatHistoryApi, CLLegacyAiChatHistoryApi } from 'models/CL/CLApiTypes';

class CLAiChatApiClass {
    async getAiChatHistory(userId: string, days: number, token: string): Promise<CLAiChatHistoryApi> {
        const response = await axios.get(`${apiPaths.CLGetAiChatHistory}${userId}/${days}`, { headers: clAdminTokenHeader(token) });
        return response.data;
    }

    async getLegacyAiChatHistory(userId: string, days: number, token: string): Promise<CLLegacyAiChatHistoryApi> {
        const response = await axios.get(`${apiPaths.CLGetLegacyAiChatHistory}${userId}/${days}`, { headers: clAdminTokenHeader(token) });
        return response.data;
    }
}

export const CLAiChatApi = new CLAiChatApiClass();
